<script>
/* eslint-disable */
import { deepClone } from '@/utils/index'
import render from '@/components/render/render.js'

const ruleTrigger = {
  'el-input': 'blur',
  'el-input-number': 'blur',
  'el-select': 'change',
  'el-radio-group': 'change',
  'el-checkbox-group': 'change',
  'el-cascader': 'change',
  'el-time-picker': 'change',
  'el-date-picker': 'change',
  'el-rate': 'change'
}

const layouts = {
  colFormItem(h, scheme) {
    const config = scheme.__config__
    const listeners = buildListeners.call(this, scheme)

    let labelWidth = config.labelWidth ? `${config.labelWidth}px` : null
    if (config.showLabel === false) labelWidth = '0'
    return (
      <el-col span={config.span}>
        <el-form-item label-width={labelWidth} prop={scheme.__vModel__} label={config.showLabel ? config.label : ''}>
          <render conf={scheme} on={listeners} />
        </el-form-item>
      </el-col>
    )
  },
  rowFormItem(h, scheme) {
    let child = renderChildren.apply(this, arguments)
    if (scheme.type === 'flex') {
      child = (
        <el-row type={scheme.type} justify={scheme.justify} align={scheme.align}>
          {child}
        </el-row>
      )
    }
    return (
      <el-col span={scheme.span}>
        <el-row gutter={scheme.gutter}>{child}</el-row>
      </el-col>
    )
  }
}
// model不能直接赋值 https://github.com/vuejs/jsx/issues/49#issuecomment-472013664
function renderFrom(h) {
  const { formConfCopy, showBtn, showEventsBtn } = this

  return (
    <el-row gutter={formConfCopy.gutter}>
      <el-form
        size={formConfCopy.size}
        label-position={formConfCopy.labelPosition}
        disabled={formConfCopy.disabled}
        label-width={`${formConfCopy.labelWidth}px`}
        ref={formConfCopy.formRef}
        props={{ model: this[formConfCopy.formModel] }}
        rules={this[formConfCopy.formRules]}
      >
        {renderFormItem.call(this, h, formConfCopy.fields)}
        {showBtn ? formConfCopy.formBtns && formBtns.call(this, h) : ''}
        {showEventsBtn ? eventsFormBtns.call(this, h) : ''}
      </el-form>
    </el-row>
  )
}

function formBtns(h) {
  let offset = 10
  return (
    <el-col>
      <el-form-item labelWidth="0">
        <div class="flexCenter">
          <el-button onClick={this.StagingForm}>暂存</el-button>
          <el-button type="primary" onClick={this.submitForm}>
            提交
          </el-button>
        </div>
      </el-form-item>
    </el-col>
  )
}

function eventsFormBtns(h) {
  let offset = 10
  return (
    <el-col>
      <el-form-item labelWidth="0">
        <div>
          <el-button size="small" onClick={this.prevStep}>上一步</el-button>
          <el-button size="small" onClick={this.StagingForm}>暂存</el-button>
          <el-button size="small" type="primary" onClick={this.submitForm}>
            提交
          </el-button>
        </div>
      </el-form-item>
    </el-col>
  )
}

function renderFormItem(h, elementList) {
  return elementList.map((scheme, index) => {
    const config = scheme.__config__
    config.label = `${config.label}`
    const layout = layouts[config.layout]

    if (layout) {
      return layout.call(this, h, scheme)
    }
    throw new Error(`没有与${config.layout}匹配的layout`)
  })
}

function renderChildren(h, scheme) {
  const config = scheme.__config__
  if (!Array.isArray(config.children)) return null
  return renderFormItem.call(this, h, config.children)
}

function setValue(event, config, scheme) {
  this.$set(config, 'defaultValue', event)
  this.$set(this[this.formConf.formModel], scheme.__vModel__, event)
}

function buildListeners(scheme) {
  const config = scheme.__config__
  const methods = this.formConf.__methods__ || {}
  const listeners = {}

  // 给__methods__中的方法绑定this和event
  Object.keys(methods).forEach(key => {
    listeners[key] = event => methods[key].call(this, event)
  })
  // 响应 render.js 中的 vModel $emit('input', val)
  listeners.input = event => setValue.call(this, event, config, scheme)

  return listeners
}

export default {
  components: {
    render
  },
  props: {
    formConf: {
      type: Object,
      required: true
    },
    showBtn: {
      type: Boolean,
      default: () => true
    },
    showEventsBtn: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    const data = {
      formConfCopy: deepClone(this.formConf),
      [this.formConf.formModel]: {},
      [this.formConf.formRules]: {}
    }
    this.initFormData(data.formConfCopy.fields, data[this.formConf.formModel])
    this.buildRules(data.formConfCopy.fields, data[this.formConf.formRules])
    return data
  },
  methods: {
    initFormData(componentList, formData) {
      componentList.forEach(cur => {
        const config = cur.__config__
        if (cur.__vModel__) formData[cur.__vModel__] = config.defaultValue
        if (config.children) this.initFormData(config.children, formData)
      })
    },
    initStaingData(formData) {
      this.formConfCopy.fields.forEach(item => {
        const val = formData[item.__vModel__]

        if (val) {
          item.__config__.defaultValue = val
        }
      })
    },
    buildRules(componentList, rules) {
      componentList.forEach(cur => {
        const config = cur.__config__
        if (Array.isArray(config.regList)) {
          if (config.required) {
            const required = { required: config.required, message: cur.placeholder }
            if (Array.isArray(config.defaultValue)) {
              required.type = 'array'
              required.message = `请至少选择一个${config.label}`
            }
            required.message === undefined && (required.message = `${config.label}不能为空`)
            config.regList.push(required)
          }
          rules[cur.__vModel__] = config.regList.map(item => {
            item.pattern && (item.pattern = eval(item.pattern))
            item.trigger = ruleTrigger && ruleTrigger[config.tag]
            return item
          })
        }
        if (config.children) this.buildRules(config.children, rules)
      })
    },
    resetForm() {
      this.formConfCopy = deepClone(this.formConf)
      this.$refs[this.formConf.formRef].resetFields()
    },
    prevStep(){
      this.$emit('prevStep')
    },
    StagingForm() {
      const currentData = this[this.formConf.formModel]
      this.$emit('staging', currentData)
    },
    submitForm() {
      this.$refs[this.formConf.formRef].validate(valid => {
        if (!valid) return false
        // 触发sumit事件
        this.$emit('submit', this[this.formConf.formModel])
        return true
      })
    }
  },
  render(h) {
    return renderFrom.call(this, h)
  }
}
</script>

<style lang="scss" scoped>
.flexCenter {
  margin: 0 auto;
  text-align: center;
}

:deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner) {
  background-color: var(--theme-color);
}

:deep(.el-checkbox__input.is-disabled.is-checked + span.el-checkbox__label) {
  color: #333 !important;
}

:deep(.el-radio__input.is-disabled.is-checked .el-radio__inner) {
  background-color: var(--theme-color);
}

:deep(.el-radio__input.is-disabled.is-checked + span.el-radio__label) {
  color: #333 !important;
}

:deep(
    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before
  ) {
  display: none;
}

:deep(
    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after,
    .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:after
  ) {
  content: '*';
  color: #ff4949;
  margin-left: 4px;
  margin-right: 0;
}
</style>
